import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Table } from '../../../../../common/table'
import { selectTableData } from '../../../store/slice'
import { TBodyCustom } from './TBodyCustom'

const TableComponent = ({ typePrefix, isDynamicReport }) => {
  const tableData = useSelector(selectTableData(typePrefix))
  const { tableHeader, ids } = tableData

  const schema = useMemo(() => {
    if (!isDynamicReport) return tableHeader
    return tableHeader.map((item, index) => ({
      ...item,
      thStyle: { justifyContent: index !== 0 ? 'end' : 'start' },
    }))
  }, [tableData])

  return (
    <Table
      autoHeightMax={400}
      ids={ids}
      isDynamicReport={isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      schema={schema}
      renderTBody={() => {
        return (
          <TBodyCustom
            ids={ids}
            schema={schema}
            typePrefix={typePrefix}
            isDynamicReport={isDynamicReport}
          />
        )
      }}
    />
  )
}

export default TableComponent
